import { placeholderColors } from '../constants/placeholderColors'

export const getColorForId = (id?: string): (typeof placeholderColors)[number] => {
  if (!id) {
    return placeholderColors[0]
  }

  const idString = String(id).toLowerCase()
  const sum = Array.from(idString)
    .map((char) => char.charCodeAt(0))
    .reduce((acc, num) => acc + num, 0)

  const index = sum % placeholderColors.length

  return placeholderColors[index]
}
